import { combineReducers } from "redux";
import { bindReducer } from "easy-redux-http-call";
import locationReducer from "./locationReducer";
import roleReducer from "./roleReducer";
import companyReducer from "./companyReducer";
import designationReducer from "./designationReducer";
import menu from "./menu";

import pincredentialReducer from "./pinreducer"

import departmentReducer from "./departmentReducer";
import addressReducer from "./addressReducer";
import documentReducer from "./documentReducer";
import employeeReducer from "./employeeReducer";
import userReducer from "./userReducer";
import leaveReducer from "./leaveReducer";
import nomineeReducer from "./nomineeReducer";
import workReducer from "./workReducer";
import educationReducer from "./educationReducer";
import projectReducer from "./projectReducer";
import projectEmployeeReducer from "./projectEmployeeReducer";
import bankDetailsReducer from "./bankDetailsReducer";
import loginReducer from "./loginReducer";
import notificationReducer from "./NotificationReducer";
import showNotificationReducer from "./showNotificationReducer";
import showActionLogsReducer from "./showActionLogsReducer";
import supplierReducer from "./supplierReducer";
import brandReducer from "./brandReducer";
import itemReducer from "./itemReducer";
import assetsReducer from "./assetsReducer";
import assetModelsReducer from "./assetModelsReducer";
import partyOrderReducer from "./partyOrderReducer";
import pageReducer from "./pageReducer";
import holidaysReducer from "./holidaysReducer";
import handoverEmployeeReducer from "./handoverEmployeeReducer";
import announcementReducer from "./announcementReducer";
import leaveBalanceReducer from "./leaveBalanceReducer";
import interviewReducer from "./interviewReducer";
import credentialReducer from "./credentialReducer";
import timeLogReducer from "./timeLogReducer";
import boardReducer from "./boardReducer";
import projectTaskReducer from "./projectTaskReducer";
import labelReducer from "./labelReducer";
import priorityReducer from "./priorityReducer";
import commentReducer from "./commentReducer";
import commonReducer from "./commonReducer";
import incidentReducer from "./incidentReducer";
import excelLeaveBalanceReducer from "./excelLeaveBalanceReducer";

import {leaveBalanceEmployeeReducer} from "./leaveBalanceReducer"
import incidentsReducer from "./incidentReducer";


const newWorkReducer = bindReducer(workReducer, { key: "workReducer" });
const newEducationReducer = bindReducer(educationReducer, {
  key: "educationReducer",
});
const newLocationReducer = bindReducer(locationReducer, {
  key: "locationReducer",
});
const newCompanyReducer = bindReducer(companyReducer, {
  key: "companyReducer",
});
const newDepartmentReducer = bindReducer(departmentReducer, {
  key: "departmentReducer",
});
const newDesignationReducer = bindReducer(designationReducer, {
  key: "designationReducer",
});
const newRoleReducer = bindReducer(roleReducer, { key: "roleReducer" });
const newAddressReducer = bindReducer(addressReducer, {
  key: "addressReducer",
});
const newDocumentReducer = bindReducer(documentReducer, {
  key: "documentReducer",
});
const newEmployeeReducer = bindReducer(employeeReducer, {
  key: "employeeReducer",
});
const newUserReducer = bindReducer(userReducer, { key: "userReducer" });
const newNomineeReducer = bindReducer(nomineeReducer, {
  key: "nomineeReducer",
});
const newProjectReducer = bindReducer(projectReducer, {
  key: "projectReducer",
});
const newProjectEmployeeReducer = bindReducer(projectEmployeeReducer, {
  key: "projectEmployeeReducer",
});
const newSupplierReducer = bindReducer(supplierReducer, {
  key: "supplierReducer",
});
const newBrandReducer = bindReducer(brandReducer, {
  key: "brandReducer",
});

const newItemReducer = bindReducer(itemReducer, {
  key: "itemReducer",
});

const newAssetModelsReducer = bindReducer(assetModelsReducer, {
  key: "assetModelsReducer",
});
const newAssetsReducer = bindReducer(assetsReducer, {
  key: "assetsReducer",
});
const newLeaveReducer = bindReducer(leaveReducer, { key: "leaveReducer" });
const newBankdetailsReducer = bindReducer(bankDetailsReducer, {
  key: "bankDetailsReducer",
});
const newLoginReducer = bindReducer(loginReducer, { key: "loginReducer" });
const newShowNotificationReducer = bindReducer(showNotificationReducer, {
  key: "showNotificationReducer",
});
const newShowActionLogsReducer = bindReducer(showActionLogsReducer, {
  key: "showActionLogsReducer",
});
const newPartyOrderReducer = bindReducer(partyOrderReducer, {
  key: "partyOrderReducer",
});
const newHolidaysReducer = bindReducer(holidaysReducer, {
  key: "holidaysReducer",
});
const newIncidentsReducer = bindReducer(incidentsReducer, {
  key: "incidentsReducer",
});
const newHandoverReducer = bindReducer(handoverEmployeeReducer, {
  key: "handoverReducer",
});

const newAnnouncementReducer = bindReducer(announcementReducer, {
  key: "announcementReducer",
});

const newLeaveBalanceReducer = bindReducer(leaveBalanceReducer, {
  key: "leaveBalanceReducer",
});

const newInterviewReducer = bindReducer(interviewReducer, {
  key: "interviewReducer",
});

const newCredentialReducer = bindReducer(credentialReducer, {
  key: "credentialReducer",
});
const newTimeLogReducer = bindReducer(timeLogReducer, {
  key: "timeLogReducer",
});
const newBoardReducer = bindReducer(boardReducer, {
  key: "boardReducer",
});
const newProjectTaskReducer = bindReducer(projectTaskReducer, {
  key: "projectTaskReducer",
});
const newLabelReducer = bindReducer(labelReducer, {
  key: "labelReducer",
});
const newPriorityReducer = bindReducer(priorityReducer, {
  key: "priorityReducer",
});
const newCommentReducer = bindReducer(commentReducer, {
  key: "commentReducer",
});

const newCommonReducer = bindReducer(commonReducer, {
  key: "commonReducer",
});
const newExcelLeaveBalanceReducer = bindReducer(excelLeaveBalanceReducer, {
  key: "excelLeaveBalanceReducer",
});

export default combineReducers({
  locationReducer: newLocationReducer,
  companyReducer: newCompanyReducer,
  departmentReducer: newDepartmentReducer,
  designationReducer: newDesignationReducer,
  roleReducer: newRoleReducer,
  addressReducer: newAddressReducer,
  documentReducer: newDocumentReducer,
  employeeReducer: newEmployeeReducer,
  userReducer: newUserReducer,
  workReducer: newWorkReducer,
  educationReducer: newEducationReducer,
  nomineeReducer: newNomineeReducer,
  projectReducer: newProjectReducer,
  projectEmployeeReducer: newProjectEmployeeReducer,
  supplierReducer: newSupplierReducer,
  brandReducer: newBrandReducer,
  itemReducer: newItemReducer,
  assetsReducer: newAssetsReducer,
  assetModelsReducer: newAssetModelsReducer,
  leaveReducer: newLeaveReducer,
  bankDetailsReducer: newBankdetailsReducer,
  loginReducer: newLoginReducer,
  showNotificationReducer: newShowNotificationReducer,
  showActionLogsReducer: newShowActionLogsReducer,
  partyOrderReducer: newPartyOrderReducer,
  holidaysReducer: newHolidaysReducer,
  incidentsReducer: newIncidentsReducer,
  handoverReducer: newHandoverReducer,
  announcementReducer: newAnnouncementReducer,
  leaveBalanceReducer: newLeaveBalanceReducer,
  interviewReducer: newInterviewReducer,
  credentialReducer: newCredentialReducer,
  timeLogReducer: newTimeLogReducer,
  boardReducer: newBoardReducer,
  projectTaskReducer: newProjectTaskReducer,
  labelReducer: newLabelReducer,
  priorityReducer: newPriorityReducer,
  commentReducer: newCommentReducer,
  commonReducer: newCommonReducer,
  excelLeaveBalanceReducer: newExcelLeaveBalanceReducer,
  notificationReducer,
  pageReducer,
  menu,
  pincredentialReducer

});
